__turbopack_context__.v({
  "active": "index-module-scss-module__w1w-8W__active",
  "bookingList": "index-module-scss-module__w1w-8W__bookingList",
  "bottomBorder": "index-module-scss-module__w1w-8W__bottomBorder",
  "breakdownBox": "index-module-scss-module__w1w-8W__breakdownBox",
  "breakdownRow": "index-module-scss-module__w1w-8W__breakdownRow",
  "breakdownTitle": "index-module-scss-module__w1w-8W__breakdownTitle",
  "button": "index-module-scss-module__w1w-8W__button",
  "calendarBox": "index-module-scss-module__w1w-8W__calendarBox",
  "date": "index-module-scss-module__w1w-8W__date",
  "header": "index-module-scss-module__w1w-8W__header",
  "item": "index-module-scss-module__w1w-8W__item",
  "left": "index-module-scss-module__w1w-8W__left",
  "legend": "index-module-scss-module__w1w-8W__legend",
  "loading": "index-module-scss-module__w1w-8W__loading",
  "name": "index-module-scss-module__w1w-8W__name",
  "none": "index-module-scss-module__w1w-8W__none",
  "notAvailable": "index-module-scss-module__w1w-8W__notAvailable",
  "note": "index-module-scss-module__w1w-8W__note",
  "popover": "index-module-scss-module__w1w-8W__popover",
  "right": "index-module-scss-module__w1w-8W__right",
  "selected": "index-module-scss-module__w1w-8W__selected",
});
